import { styled as i, Box as o, Typography as u, useTheme as x, useMediaQuery as g } from "@mui/material";
import { StepState as t } from "../../../../constants/tutorial.js";
import { noForwardProps as w } from "../../../../util/styled/index.js";
import { forwardRef as C } from "react";
import { jsxs as m, jsx as n } from "react/jsx-runtime";
const l = 30, b = i(o, w)`
  flex-shrink: 0;
  display: flex;
  row-gap: ${l}px;
  ${(e) => e.theme.breakpoints.up("res768")} {
    row-gap: 0px;
  }

  flex-direction: column;

  transform: translateY(${(e) => e.__transformY}px);
  transition: all 0.3s ease;
`, $ = (e, r) => r === e ? t.active : e < r ? t.completed : t.inactive, v = i(o)`
  width: 30px;
  height: 30px;
  background-color: ${(e) => {
  switch (e.state) {
    case t.completed:
      return "#F5C75B";
    case t.active:
      return "#F5C75B";
    case t.inactive:
      return "#3B3B3B";
  }
}};

  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  z-index: 0;
`, B = i(u)`
  font-size: 18px;
  font-weight: 500;
  color: ${(e) => {
  switch (e.state) {
    case t.completed:
      return "#fff";
    case t.active:
      return "#fff";
    case t.inactive:
      return "#B5B5B5";
  }
}};
`, y = i(u)`
  text-align: left;
  ${(e) => e.theme.breakpoints.up("res768")} {
    font-size: 16px;
  }
  ${(e) => e.theme.breakpoints.down("res768")} {
    font-size: 12px;
  }
  font-weight: ${(e) => {
  switch (e.state) {
    case t.completed:
      return 500;
    case t.active:
      return 500;
    case t.inactive:
      return 300;
  }
}};
  color: ${(e) => {
  switch (e.state) {
    case t.completed:
      return "#F5C75B";
    case t.active:
      return "#F5C75B";
    case t.inactive:
      return "#4C4C4C";
  }
}};
`, S = i(o)`
  display: flex;
  align-items: center;
  row-gap: 4px;
  column-gap: 15px;

  ${(e) => e.theme.breakpoints.up("res768")} {
    margin-bottom: ${l}px;
    flex-direction: row;
    column-gap: 15px;
    position: relative;
    align-items: flex-start;
  }
`, k = i(o)`
  width: 2px;
  height: calc(100% + ${l}px);
  position: absolute;
  background-color: #4c4c4c;
`, F = i(o)`
  display: flex;
  justify-content: center;
  align-items: top;
`, L = C(function({
  title: r,
  index: p,
  showLine: c,
  state: s
}, a) {
  return /* @__PURE__ */ m(S, {
    ref: a,
    children: [/* @__PURE__ */ m(F, {
      children: [c && /* @__PURE__ */ n(k, {}), /* @__PURE__ */ n(v, {
        state: s,
        children: /* @__PURE__ */ n(B, {
          state: s,
          children: p + 1
        })
      })]
    }), /* @__PURE__ */ n(o, {
      children: /* @__PURE__ */ n(y, {
        state: s,
        children: r
      })
    })]
  });
}), T = ({
  steps: e,
  currentStepIndex: r
}) => {
  const p = x(), c = g(p.breakpoints.down("res768")), s = !c || r < 2 ? 0 : -((r - 1) * (30 + l));
  return /* @__PURE__ */ n(b, {
    __transformY: s,
    children: e.map((a, f) => {
      const h = f === e.length - 1, d = $(f, r);
      return /* @__PURE__ */ n(L, {
        title: a.title,
        index: f,
        state: d,
        showLine: !c && !h
      }, a.id);
    })
  });
};
export {
  T as default
};
//# sourceMappingURL=StepIndicator.js.map
